import GetBasketRequestModelBase from '../_generated/modelBases/get-basket-request-model-base';

export default class GetBasketRequestModel extends GetBasketRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
